<template>
  <div>
    <b-container class="gen-header">
      <b-row>
        <b-col sm="12">
          <div class="childs">
            <div class="page-title">Media</div>
            <!-- <b-breadcrumb :items="items"></b-breadcrumb> -->
          </div>
        </b-col>
      </b-row>
    </b-container>
    <news-page></news-page>
    <call-us></call-us>
  </div>
</template>

<script>
// @ is an alias to /src
import NewsPage from "@/components/NewsPage.vue";
import CallUs from "@/components/CallUs.vue";

export default {
  created() {
    document.title = "Media";
  },
  name: "News",
  data() {
    return {
      drawer: true,
      images: {
        headImage: require("@/assets/news.png")
      },
      items: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Media",
          active: true
        }
      ]
    };
  },
  components: {
    "news-page": NewsPage,
    "call-us": CallUs
  }
};
</script>
<style scoped></style>
